import './ORHL.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class ORHL extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

};
